<template>
  <div class="card_item" v-for="(item,index) in allUserVip" :key="item.id">
    <div :class="`card_${index} box`">
      <div :class="`top_box_${index} topBox`">
        {{ $t(`${productSortSwitch(item?.productSort)}`) }}
      </div>
      <div style="margin: 15px auto 5px auto;text-align: center">
        <template v-if="item.productSort === 5">
          <!--    普通用户-->
          <span class="free_text">{{ $t('common.mf') }}</span>
        </template>
        <template v-else>
          <span class="price_number">{{ item.productCheapPrice }}</span>
          <span class="units">{{ $t('userinfo.vip.price.units') }}</span>
        </template>
      </div>
      <div class="pre_price" style="text-decoration:none !important;">
        {{ $t('userinfo.vip.pre.price', {price: item.productPrice}) }}
      </div>
      <div style="margin-top: 5px;">
        <template
            v-if="item.productSort !== 5 && ((!userInfo?.vipExpireDate && userInfo.isVip === 0) || (userInfo?.vipExpireDate && userInfo.isVip!==0))">
          <div v-if="memberType===item.productSort" class="buy_button" @click="handleClickToBuy(item,2)">
            {{ $t('common.ph16') }}
          </div>
          <div v-else :class="[memberType<item.productSort?'buy_button':'disable_buy_button']"
               @click="handleClickToBuy(item,1)">
            {{
              $t('common.buy.now')
            }}
          </div>
        </template>
        <div v-else style="height: 30px"></div>
      </div>
      <div class="line-text_user_interests">{{ $t('userinfo.vip.user.interests') }}</div>
      <div
          style="display: flex;flex-direction: column;align-items: flex-start;justify-content: center;padding: 0px 5px;">
        <div style="display: flex;justify-content: space-between;width: 100%" class="item_user">
          <div>{{ $t('userinfo.vip.work') }}</div>
          <div class="sp_value">{{ $t('displace.a', {number: item.totalPosition}) }}</div>
        </div>
        <div style="display: flex;justify-content: space-between;width: 100%" class="item_user">
          <div>{{ $t('userinfo.vip.space') }}</div>
          <div class="sp_value">{{ $t('userinfo.G.number', {number: item.effectiveLocation}) }}</div>
        </div>
        <div style="display: flex;justify-content: space-between;width: 100%" class="item_user">
          <div>{{ $t('userinfo.vip.edm') }}</div>
          <div class="sp_value">{{ $t('userinfo.edm.number', {number: item.edmTotalNum}) }}</div>
        </div>
        <div style="display: flex;justify-content: space-between;width: 100%" class="item_user">
          <div>{{ $t('userinfo.vip.AI') }}</div>
          <div class="sp_value">{{ $t('userinfo.AI.number', {number: item.totalAiNum}) }}</div>
        </div>
        <div style="display: flex;justify-content: space-between;width: 100%;align-items: center" class="item_user">
          <div>{{ $t('userinfo.vip.preferential') }}</div>
          <div class="sp_value" v-if="item.isCheap">
            <el-icon style="color:#D93737;font-size: 14px;">
              <Check/>
            </el-icon>
          </div>
          <div class="sp_value" v-else>
            <el-icon style="color: #909090;font-size: 14px;">
              <Close/>
            </el-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {productSortSwitch} from "../../../utils/util";

const store = useStore()
const router = useRouter()
const allUserVip = computed(() => (store.state.buystorage.allUserVip || []).filter(item => item?.productSort !== 9))
const userInfo = computed(() => store.state.user.userInfo)

const {memberType} = defineProps({
  memberType: {
    type: Number,
    default: 1,
  }
})

onMounted(async () => {
  await store.dispatch("buystorage/getMailProductListApis", 2)
})


const handleClickToBuy = (item, type) => {
  if (memberType > item.productSort) return
  const {productSort, id} = item
  console.log(productSort, 'productSort')
  router.push({path: '/personal/buystorage', query: {indexId: id, productSort: productSort, type: type}})
}

</script>


<style lang="less" scoped>
.card_item {
  width: 24.5%;
  min-width: 24%;
  height: 340px;
  //background: red;
  border-radius: 5px;
  box-sizing: border-box;
}

.box {
  border-radius: 5px 5px 5px 5px;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  .topBox {
    height: 50px;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 18px;
    text-align: center;
    line-height: 50px;
  }

  .top_box_0 {
    background: #E3E3E3;
    color: #000000;
  }

  .top_box_1 {
    background: url("../../../assets/vip/2.jpg") no-repeat center/cover;
    color: #72441A;
  }

  .top_box_2 {
    background: url("../../../assets/vip/3.jpg") no-repeat center/cover;
    color: #FFFFFF;
  }

  .top_box_3 {
    background: url("../../../assets/vip/4.jpg") no-repeat center/cover;
    color: #FFD8A9;
  }
}

.card_0 {
  border: 1px solid #E3E3E3;
}

.card_1 {
  border: 1px solid #F4C794;
}

.card_2 {
  border: 1px solid #999999;
}

.card_3 {
  border: 1px solid #4D5058;
}

.free_text {
  display: inline-block;
  width: 100%;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: #000000;
}

.price_number {
  width: 100%;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: #D93737;
}

.units {
  display: inline;
}

.pre_price {
  text-align: center;
  text-decoration: line-through;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #9B9B9B;
  line-height: 18px;
}

.buy_button {
  margin: auto;
  width: 130px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: rgba(217, 55, 55, 0.15);
  border-radius: 4px;
  border: 1px solid #D93737;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #D93737;
  cursor: pointer;
}

.disable_buy_button {
  margin: auto;
  width: 130px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #f2f2f2; /* 浅灰背景 */
  border-radius: 4px;
  border: 1px solid #ccc; /* 灰色边框 */
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999; /* 字体变灰 */
  cursor: not-allowed;
}

.line-text_user_interests {
  width: 80%;
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 14px;
  margin: 10px auto;
  color: #999;
}

.line-text_user_interests::before,
.line-text_user_interests::after {
  content: '';
  flex: 1;
  height: 1px;
  background-color: #ccc;
}

.line-text_user_interests::before {
  margin-right: 8px;
}

.line-text_user_interests::after {
  margin-left: 8px;
}

.item_user {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #333333;
  margin: 4px 0px;
}

.sp_value {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 13px;
  color: #9B9B9B;
  height: 14px !important;
}
</style>